// Hooks
import { useGetCurrUser, useBreakpoints } from 'hooks';
// Helpers
import { isActiveStore, isUserCustomer } from 'helpers/user';
// Constants
import { PROFILE } from 'constants/routes';
// Components
import ShareQRButton from 'components/common3/ShareQRButton/ShareQRButton';
// UI3
import LinkButton from 'ui3/LinkButton/LinkButton';
// Styles
import styles from './ViewEditShareProfileButtons.module.scss';

type ViewEditShareProfileButtonsProps = {
  showEditButton?: boolean;
};

const ViewEditShareProfileButtons = ({
  showEditButton = false,
}: ViewEditShareProfileButtonsProps) => {
  const { data } = useGetCurrUser();
  const slug = data?.me?.slug;
  const { isBreakpointL } = useBreakpoints();

  const isStoreActive = isActiveStore(data);
  const isBasicUser = isUserCustomer(data);

  const shareButtonSize = isBreakpointL || showEditButton ? 'medium' : 'small';

  if (!isStoreActive || isBasicUser) return null;

  return (
    <div className={styles.root}>
      {showEditButton ? (
        <LinkButton
          type="button"
          variant="primary"
          size="medium"
          link={PROFILE}
          className={styles.viewProfileButton}
        >
          Edit Profile
        </LinkButton>
      ) : (
        <LinkButton
          type="button"
          variant="secondary"
          size={isBreakpointL ? 'medium' : 'small'}
          link={`/${slug}` || ''}
          className={styles.viewProfileButton}
        >
          View Profile
        </LinkButton>
      )}
      {slug && (
        <ShareQRButton
          size={shareButtonSize}
          slug={slug}
          storeName={
            isBreakpointL ? data?.me?.storeDetails?.storeName || '' : ''
          }
          wrapperClassName={styles.shareButton}
          {...(!isBreakpointL && { hideText: true })}
        />
      )}{' '}
    </div>
  );
};

export default ViewEditShareProfileButtons;
